import React, { Component } from 'react';
import SideBarModule from './SideBarModule';
import { ItemTypes, PanelTypes } from '../../constants/sidebar/DragAndDropTypes';
import { DropTarget } from 'react-dnd';
import { connect } from 'react-redux'
import { arrangeActiveModule, moveInModule, moveOutModule } from '../../actions/sidebar'

@connect(state => ({
}), dispatch => ({
    handleArrangeActiveModule: (panelName, oldIndex, newIndex, module) => {
        dispatch(arrangeActiveModule(panelName, oldIndex, newIndex, module))
    },
    handleMoveInModule: (panelName, index, module) => {
        dispatch(moveInModule(panelName, index, module))
    },
    handleMoveOutModule: (panelName, moduleId) => {
        dispatch(moveOutModule(panelName, moduleId))
    },
    handleRemoveModule: (panelName, moduleId) => {
        dispatch(panelName, moduleId)
    }
}))
@DropTarget(ItemTypes.MODULE, {
    canDrop(props, monitor, component) {
        return true;
    },
    hover(props, monitor, component) {

        // dnd shallow hover 인 경우
        if(monitor.isOver({ shallow: true })){
            const draggingItem = monitor.getItem();
            const { modules }= component.props;
            const hoverIndex = (modules.length - 1);

            // 자기 자신의 위에 있으면 hover 처리 하지 않음
            if(modules.findIndex((module) => module.moduleId === draggingItem.module.moduleId) !== -1){
                return;
            }
            component.handleMoveIn(draggingItem, hoverIndex, draggingItem.from);
        }
    }
}, (connect, monitor) => {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop()
    };
})
class SidebarPanel extends Component {

    constructor(props){
        super(props);

        const panelIndex = PanelTypes.SIDEBAR + props.idx;
        this.state = {
            panelIndex : panelIndex
        };

        this.handleMoveIn = this.handleMoveIn.bind(this);
        this.handleMoveOut = this.handleMoveOut.bind(this);
    }

    handleMoveIn(draggingItem, hoverIndex, from) {

        const { handleMoveInModule, handleArrangeActiveModule, modules } = this.props;

        let thisPanelIdx = this.state.panelIndex;
        if(thisPanelIdx === from) {
            if(draggingItem.index !== hoverIndex) {
                const module = modules.find((module) => module.moduleId === draggingItem.draggingId);
                draggingItem.module = module;
                handleArrangeActiveModule(thisPanelIdx, draggingItem.index, hoverIndex, draggingItem.module);
            }
        }else{
            draggingItem.moveFromPanel(draggingItem.module.moduleId); // 기존에 모듈이 들어 있던 패널에서 제거.
            handleMoveInModule(thisPanelIdx, hoverIndex, draggingItem.module);
        }
        draggingItem.from = thisPanelIdx; // 패널 아이디 갱신
        draggingItem.index = hoverIndex; // index 갱신
        draggingItem.moveFromPanel = this.handleMoveOut; // 다른 패널로 이동시에 기존에서 제거할 메소드 재할당

    }

    handleMoveOut(moduleId){

        const { handleMoveOutModule} = this.props;
        const { panelIndex } = this.state;

        handleMoveOutModule(panelIndex, moduleId);

    }

    render() {
        const { connectDropTarget, idx, modules, moduleCount } = this.props;
        const { panelIndex } = this.state;

        let moduleList;
        moduleList = modules.map((module, index) => <SideBarModule key={module.moduleId}
                                                                    index={index}
                                                                    module={module}
                                                                    sidebarIdx={idx}
                                                                    panelIndex={panelIndex}
                                                                    moveIn={this.handleMoveIn}
                                                                    moveOut={this.handleMoveOut}
                                                                    moduleCount={moduleCount}
                                                                    />
        );

        return connectDropTarget(
            <div className="wrap_order">
                <strong className="tit_set">사이드바{(idx + 1)}</strong>
                <div className="list_order">
                    { moduleList }
                </div>
            </div>
        );

    }
}

export default SidebarPanel;
